import { getAuth } from "firebase/auth";
import { getDownloadURL, getStorage, listAll, ref } from "firebase/storage";
import {
  PROFILE_CONSTANT_REQUEST,
  PROFILE_CONSTANT_SUCCESS,
  PROFILE_CONSTANT_FAIL,
} from "../constants/constants";

export const listProfileImageAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: PROFILE_CONSTANT_REQUEST,
    });

    const listImages = async () => {
      //   setIsImageUploading(true);
      getAuth().onAuthStateChanged(async () => {
        const id = getAuth().currentUser.uid;

        listAll(ref(getStorage(), `business_logo/${id}`)).then(
          async ({ prefixes, items }) => {
            await getDownloadURL(items[0]);
            // setIsImageUploading(false);
          }
        );
      });
    };

    dispatch({
      type: PROFILE_CONSTANT_SUCCESS,
      payload: listImages,
    });
  } catch (error) {
    dispatch({
      type: PROFILE_CONSTANT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
